export type AnyFunction = (...args: any[]) => any

export type AnyAsyncFunction = (...args: any[]) => Promise<any>

/** The underlying result type of the async function `F`. `F: (args => Promise<T>) -> T` */
export type Promised<F extends AnyAsyncFunction> = Awaited<ReturnType<F>>

export type JSONValue = string | number | boolean | {[x: string]: JSONValue} | JSONValue[]

export type DeepReadonly<T> = Readonly<{
    [K in keyof T]: T[K] extends number | string | symbol
        ? T[K]
        : T[K] extends (infer A)[]
        ? Readonly<DeepReadonly<A>[]>
        : DeepReadonly<T[K]>
}>
